import { Injectable, Injector } from '@angular/core';
import { BitfApiService } from '@bitf/services/api/bitf-api.service';

@Injectable({
  providedIn: 'root',
})
export class RoutesService extends BitfApiService {
  constructor(protected injector: Injector) {
    super('routes', injector);
  }
}
